// extracted by css-extract-rspack-plugin
export default {"hiddenIcon":"BlobActionsMenu-module__hiddenIcon__Jq8DpMr"};